<template>
  <el-select
    ref="state"
    v-model="selected"
    :placeholder="$t('selecione-uma-opcao')"
    @change="update()"
  >
    <el-option
      v-for="row of states"
      :key="row.id"
      :label="`${row.id} - ${row.name}`"
      :value="row.id"
    ></el-option>
  </el-select>
</template>

<script>
import { ServicesService } from "@/services/customers/services.services";
export default {
  name: "ServicesList",
  data: function () {
    return {
      states: [],
      selected: "",
    };
  },
  methods: {
    fetchRecords() {
      const vm = this;
      vm.states.push({ id: "AC", name: "Acre" });
      vm.states.push({ id: "AL", name: "Alagoas" });
      vm.states.push({ id: "AP", name: "Amapá" });
      vm.states.push({ id: "AM", name: "Amazonas" });
      vm.states.push({ id: "BA", name: "Bahia" });
      vm.states.push({ id: "CE", name: "Ceará" });
      vm.states.push({ id: "DF", name: "Distrito Federal" });
      vm.states.push({ id: "ES", name: "Espírito Santo" });
      vm.states.push({ id: "GO", name: "Goiás" });
      vm.states.push({ id: "MA", name: "Maranhão" });
      vm.states.push({ id: "MT", name: "Mato Grosso" });
      vm.states.push({ id: "MS", name: "Mato Grosso do Sul" });
      vm.states.push({ id: "MG", name: "Minas Gerais" });
      vm.states.push({ id: "PA", name: "Pará" });
      vm.states.push({ id: "PB", name: "Paraíba" });
      vm.states.push({ id: "PR", name: "Paraná" });
      vm.states.push({ id: "PE", name: "Pernambuco" });
      vm.states.push({ id: "PI", name: "Piauí" });
      vm.states.push({ id: "RJ", name: "Rio de Janeiro" });
      vm.states.push({ id: "RN", name: "Rio Grande do Norte" });
      vm.states.push({ id: "RS", name: "Rio Grande do Sul" });
      vm.states.push({ id: "RO", name: "Rondônia" });
      vm.states.push({ id: "RR", name: "Roraima" });
      vm.states.push({ id: "SC", name: "Santa Catarina" });
      vm.states.push({ id: "SP", name: "São Paulo" });
      vm.states.push({ id: "SE", name: "Sergipe" });
      vm.states.push({ id: "TO", name: "Tocantins" });
    },
    update() {
      const vm = this;
      vm.$emit("input", vm.selected);
      vm.$emit("selected", vm.selected);
    },
  },
  mounted() {
    const vm = this;
    vm.fetchRecords();
  },
};
</script>